import './App.css';
import { HashRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/home';
import Contacts from "./pages/contacts";

function App() {
  return (
    <HashRouter>
        <Routes>
            <Route index element={<Home />} />
            <Route path={'/contacts'} element={<Contacts />} />
        </Routes>
    </HashRouter>
  );
}

export default App;
